
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lgDo7", function(module, exports) {

$parcel$export(module.exports, "UniformEntryPage", function () { return $84c3366e54b9b039$export$f0d4a992b207ed41; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $dWbel = parcelRequire("dWbel");

var $4ktyF = parcelRequire("4ktyF");

var $luVwe = parcelRequire("luVwe");
parcelRequire("8ch47");
var $9AjEB = parcelRequire("9AjEB");

var $9iWJ8 = parcelRequire("9iWJ8");
const $84c3366e54b9b039$export$f0d4a992b207ed41 = ({ composition: composition, compositionMetrics: compositionMetrics, isUniformPlayground: isUniformPlayground, isAllowPostMessage: isAllowPostMessage })=>{
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const [dxpMigrationExposureFired, fireDxpMigrationExposure] = (0, $9iWJ8.useExperimentExposure)((0, $9iWJ8.experiments).dxpMigrationSoftwarePage);
    const { compositionFetchStart: compositionFetchStart, compositionCacheStatus: compositionCacheStatus, ssrEndTime: ssrEndTime } = compositionMetrics || {};
    const sendPageRenderAnalyticsEvent = (0, $iSvIT.useCallback)((pageRenderTime, ssrEndTime, compositionFetchStart, fcp)=>{
        if (pageRenderTime && analyticsClient) analyticsClient.sendUIEvent({
            action: "pageRender",
            actionSubject: "uniformPage",
            source: window.location.pathname,
            attributes: {
                pageRenderTime: pageRenderTime,
                compositionFetchStart: compositionFetchStart,
                ssrEndTime: ssrEndTime,
                compositionCacheStatus: compositionCacheStatus,
                fcp: fcp,
                isUniformPlayground: isUniformPlayground || false
            }
        });
    }, [
        analyticsClient,
        compositionCacheStatus,
        isUniformPlayground
    ]);
    (0, $iSvIT.useEffect)(()=>{
        // @ts-ignore
        const measureFirstContentfulPaint = ()=>{
            try {
                // First, check if FCP is already available
                const paintEntries = performance.getEntriesByType("paint");
                const firstContentfulPaint = paintEntries.find((entry)=>entry.name === "first-contentful-paint");
                if (firstContentfulPaint && ssrEndTime && compositionFetchStart) {
                    const fcp = firstContentfulPaint.startTime;
                    // Calculate page render time
                    const pageRenderTime = ssrEndTime - compositionFetchStart + fcp;
                    if (pageRenderTime) sendPageRenderAnalyticsEvent(pageRenderTime, ssrEndTime, compositionFetchStart, fcp);
                    return firstContentfulPaint.startTime;
                }
                // If FCP isn't available yet, observe for it
                const observer = new PerformanceObserver((list)=>{
                    const entries = list.getEntries();
                    const fcpEntry = entries.find((entry)=>entry.name === "first-contentful-paint");
                    if (fcpEntry && compositionFetchStart && ssrEndTime) {
                        const fcp = fcpEntry.startTime;
                        // Calculate page render time
                        const pageRenderTime = ssrEndTime - compositionFetchStart + fcp;
                        if (pageRenderTime) sendPageRenderAnalyticsEvent(pageRenderTime, ssrEndTime, compositionFetchStart, fcp);
                        observer.disconnect();
                    }
                });
                observer.observe({
                    entryTypes: [
                        "paint"
                    ]
                });
                // Cleanup observer after 10 seconds to prevent memory leaks
                setTimeout(()=>{
                    observer.disconnect();
                }, 10000);
                return undefined;
            } catch (error) {
                console.warn("Error measuring Page Render Time:", error);
                return undefined;
            }
        };
        measureFirstContentfulPaint();
    }, [
        compositionFetchStart,
        compositionMetrics,
        sendPageRenderAnalyticsEvent,
        ssrEndTime
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (!dxpMigrationExposureFired) fireDxpMigrationExposure();
    }, [
        dxpMigrationExposureFired,
        fireDxpMigrationExposure
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4ktyF.default), {
        fallback: /*#__PURE__*/ (0, $loA2J.jsx)((0, $luVwe.FourOhFourPageTemplate), {}),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            "data-testid": "uniform-entry-page-root",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Suspense), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9AjEB.UniformEntryPageTemplate), {
                    composition: composition,
                    isUniformPlayground: isUniformPlayground,
                    isAllowPostMessage: isAllowPostMessage
                })
            })
        })
    });
};

});
parcelRegister("luVwe", function(module, exports) {

$parcel$export(module.exports, "FourOhFourPageTemplate", function () { return $7767538b4499ca14$export$580adf4c24c28053; });
// @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $kex29 = parcelRequire("kex29");

var $cP0Yq = parcelRequire("cP0Yq");

var $eXdLM = parcelRequire("eXdLM");
const $7767538b4499ca14$export$580adf4c24c28053 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.default), {
                    isShowTryNowLink: true,
                    tryNowLinkCtaButtonColor: "light_grey",
                    productKey: "404"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $eXdLM.MainSection), {})
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $kex29.GlobalFooter), {})
        ]
    });
};

});

parcelRegister("8ch47", function(module, exports) {
$parcel$export(module.exports, "UniformEntryPageTemplate", function () { return (parcelRequire("9AjEB")).UniformEntryPageTemplate; });

var $9AjEB = parcelRequire("9AjEB");

});
parcelRegister("9AjEB", function(module, exports) {

$parcel$export(module.exports, "UniformEntryPageTemplate", function () { return $c0c979c21b492ce7$export$8328465fb6b6a7d2; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $4ktyF = parcelRequire("4ktyF");

var $luVwe = parcelRequire("luVwe");

var $aME7P = parcelRequire("aME7P");
const $c0c979c21b492ce7$export$8328465fb6b6a7d2 = ({ composition: composition, isUniformPlayground: isUniformPlayground, isAllowPostMessage: isAllowPostMessage })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4ktyF.default), {
        fallback: /*#__PURE__*/ (0, $loA2J.jsx)((0, $luVwe.FourOhFourPageTemplate), {}),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aME7P.UniformWrapper), {
            composition: composition,
            isUniformPlayground: isUniformPlayground,
            isAllowPostMessage: isAllowPostMessage
        })
    });
};

});



parcelRegister("7Tq4R", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $a2725444c60d8295$export$2cd8252107eb640b; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $9jv6U = parcelRequire("9jv6U");

var $01JF1 = parcelRequire("01JF1");

var $cGDYS = parcelRequire("cGDYS");

var $7RyUO = parcelRequire("7RyUO");

var $dunoe = parcelRequire("dunoe");

var $k2OeR = parcelRequire("k2OeR");

var $j0nzO = parcelRequire("j0nzO");

var $14zFQ = parcelRequire("14zFQ");

var $dJ4mM = parcelRequire("dJ4mM");

var $6wlNh = parcelRequire("6wlNh");

var $9uFWm = parcelRequire("9uFWm");

var $EyEcw = parcelRequire("EyEcw");

var $9Dbz6 = parcelRequire("9Dbz6");
window.BUILD_KEY = "p-f4959886e8";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $cGDYS.default)()
    }
};
const $a2725444c60d8295$export$2cd8252107eb640b = (Component)=>{
    const isStatic = typeof window !== "undefined" && window.IS_STATIC;
    const analyticsWebClient = (0, $dunoe.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $9Dbz6.parseRoute)(window.location);
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== "undefined") locationData = {
        countryIsoCode: window.countryCode || "",
        regionIsoCode: window.regionIsoCode || ""
    };
    const isPerfOnetrustEnabled = (0, $k2OeR.isPerformanceOnetrustEnabled)(typeof window !== "undefined" ? window.optanonConsentCookie : (0, $k2OeR.extractOptanonConsentCookie)(document.cookie), locationData);
    isPerfOnetrustEnabled && (0, $7RyUO.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $9jv6U.parse)(document.cookie) : {};
    const userAgent = typeof window !== "undefined" ? window.navigator.userAgent : "";
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $EyEcw.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    // Below is for debugging edge - will be removed
    window.ssrAnonId = window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
    // We can't feature gate below code as this is done before initialization so just overriding for the path we are testing
    if ((0, $6wlNh.isEdgeCachingPath)(window.location.pathname)) {
        // Override for Edge Caching
        (0, $6wlNh.overrideAjsAnonIdFromCookie)();
        (0, $6wlNh.overrideCustomAttributes)();
    }
    (0, $j0nzO.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(()=>{
        if (isStatic) {
            // @ts-ignore
            const root = (0, $01JF1.createRoot)(document.getElementById("wac"));
            root.render(/*#__PURE__*/ (0, $loA2J.jsx)((0, $9uFWm.SentryIntlProvider), {
                locale: locale,
                messages: window.SSR_languagePack,
                cookies: document.cookie,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dJ4mM.PageWrapper), {
                    analyticsWebClient: analyticsWebClient,
                    pureClientMode: true,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    countryCode: window.countryCode,
                    templates: window.templates,
                    partnerTemplates: window.partnerTemplates,
                    collections: window.collections,
                    categories: window.categories,
                    composition: window._uniformPreloadedComposition,
                    // @ts-ignore
                    compositionMetrics: window.compositionMetrics,
                    isUniformPlayground: window.isUniformPlayground,
                    isAllowPostMessage: window.isAllowPostMessage,
                    teamType: window.teamType,
                    keyword: window.keyword,
                    referrer: window.referrer,
                    mlTemplateIds: window.mlTemplateIds,
                    track: window.track,
                    anchor: window.anchor,
                    subAnchor: window.subAnchor,
                    clusterTag: window.clusterTag,
                    auxiaResponse: window.auxiaResponse,
                    transactionAccounts: window.transactionAccounts,
                    userAgent: userAgent,
                    children: Component
                })
            }));
        } else (0, $01JF1.hydrateRoot)(// @ts-ignore
        document.getElementById("wac-root"), /*#__PURE__*/ (0, $loA2J.jsx)((0, $9uFWm.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $14zFQ.Layout), {
                analyticsWebClient: analyticsWebClient,
                location: window.location,
                pricing: window.prices,
                availableProducts: window.availableProducts,
                // @ts-ignore
                tutorial: window.tutorial,
                templates: window.templates,
                partnerTemplates: window.partnerTemplates,
                collections: window.collections,
                categories: window.categories,
                userProfile: window.userProfile,
                userProfileStatus: window.userProfileStatus,
                userContext: window.userContext,
                userContextStatus: window.userContextStatus,
                loggedOutContext: window.loggedOutContext,
                loggedOutContextStatus: window.loggedOutContextStatus,
                countryCode: window.countryCode,
                composition: window._uniformPreloadedComposition,
                // @ts-ignore
                compositionMetrics: window.compositionMetrics,
                isUniformPlayground: window.isUniformPlayground,
                isAllowPostMessage: window.isAllowPostMessage,
                teamType: window.teamType,
                keyword: window.keyword,
                mlTemplateIds: window.mlTemplateIds,
                referrer: window.referrer,
                anchor: window.anchor,
                subAnchor: window.subAnchor,
                clusterTag: window.clusterTag,
                auxiaResponse: window.auxiaResponse,
                transactionAccounts: window.transactionAccounts,
                userAgent: userAgent,
                children: Component
            })
        }), {
            onRecoverableError: (error, errorInfo)=>{
                var _document_getElementById;
                (_document_getElementById = document.getElementById("wac-root")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.setAttribute("hydration-error", "true");
            }
        });
    });
};

});

parcelRegister("ZQ88u", function(module, exports) {

$parcel$export(module.exports, "isTextComponent", function () { return $b38aef75a4439eb4$export$4bf69398599dba31; });
$parcel$export(module.exports, "isAssetComponent", function () { return $b38aef75a4439eb4$export$61be03ff0b6c6c6e; });
$parcel$export(module.exports, "isEmbedComponent", function () { return $b38aef75a4439eb4$export$9846e8db24db36f4; });
$parcel$export(module.exports, "isProTipText", function () { return $b38aef75a4439eb4$export$cfaa1a75f40e26f5; });
$parcel$export(module.exports, "isTwitterComponent", function () { return $b38aef75a4439eb4$export$99fa2f2e7e0ad570; });
$parcel$export(module.exports, "isCallToAction", function () { return $b38aef75a4439eb4$export$ab20f6e6e266a5a6; });
$parcel$export(module.exports, "isQuestionComponent", function () { return $b38aef75a4439eb4$export$9c5fde415fc473c8; });
$parcel$export(module.exports, "isCallOutComponent", function () { return $b38aef75a4439eb4$export$a58e7eebbfe3c431; });
const $b38aef75a4439eb4$export$4bf69398599dba31 = (component)=>{
    return component.__typename === "ContentPlatformTextComponent" || component.__typename === "TextComponent";
};
const $b38aef75a4439eb4$export$61be03ff0b6c6c6e = (component)=>{
    return component.__typename === "ContentPlatformAssetComponent" || component.__typename === "AssetComponent";
};
const $b38aef75a4439eb4$export$9846e8db24db36f4 = (component)=>{
    return component.__typename === "ContentPlatformEmbeddedVideoAsset" || component.__typename === "EmbeddedVideoAsset";
};
const $b38aef75a4439eb4$export$cfaa1a75f40e26f5 = (component)=>{
    return component.__typename === "ContentPlatformProTipComponent" || component.__typename === "ProTipComponent";
};
const $b38aef75a4439eb4$export$99fa2f2e7e0ad570 = (component)=>{
    return component.__typename === "ContentPlatformTwitterComponent" || component.__typename === "TwitterComponent";
};
const $b38aef75a4439eb4$export$ab20f6e6e266a5a6 = (component)=>{
    return component.__typename === "ContentPlatformCallToAction" || component.__typename === "CallToAction";
};
const $b38aef75a4439eb4$export$9c5fde415fc473c8 = (component)=>{
    return component.__typename === "ContentPlatformQuestionComponent" || component.__typename === "QuestionComponent";
};
const $b38aef75a4439eb4$export$a58e7eebbfe3c431 = (component)=>{
    return component.__typename === "ContentPlatformCallOutComponent" || component.__typename === "CallOutComponent";
};

});

parcelRegister("1lZ6p", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a02f6f2bebc5924b5c7f92f48f61953>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0fc726477ca8709d$var$_react = $0fc726477ca8709d$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $0fc726477ca8709d$var$_baseNew = $0fc726477ca8709d$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $0fc726477ca8709d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "InformationCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: For highlighting information when less visual emphasis is needed within the UI compared to the filled information status icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0fc726477ca8709d$var$InformationCircleIcon = (props)=>/*#__PURE__*/ $0fc726477ca8709d$var$_react.default.createElement($0fc726477ca8709d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25.25H6.5v-1.5H8a.75.75 0 0 1 .75.75v5h-1.5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$0fc726477ca8709d$var$InformationCircleIcon.displayName = "InformationCircleIcon";
var $0fc726477ca8709d$var$_default = module.exports.default = $0fc726477ca8709d$var$InformationCircleIcon;

});

parcelRegister("foKoE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5f93e34be6622a1cb8208e9984b09a45>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b35d164c36c1b05f$var$_react = $b35d164c36c1b05f$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $b35d164c36c1b05f$var$_baseNew = $b35d164c36c1b05f$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $b35d164c36c1b05f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Lightbulb".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: learnings in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b35d164c36c1b05f$var$LightbulbIcon = (props)=>/*#__PURE__*/ $b35d164c36c1b05f$var$_react.default.createElement($b35d164c36c1b05f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10 12.5H6V14a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5zm-2-11c-3.022 0-4.935 3.243-3.473 5.888L5.535 9.21c.303.548.463 1.164.465 1.79h4a3.7 3.7 0 0 1 .465-1.79l1.008-1.822C12.935 4.743 11.022 1.5 8 1.5M11.5 14a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-2.988a2.2 2.2 0 0 0-.277-1.075L3.215 8.114C1.2 4.47 3.835 0 8 0c4.164 0 6.8 4.47 4.785 8.114l-1.008 1.823a2.2 2.2 0 0 0-.277 1.075z"/>`
    }, props));
$b35d164c36c1b05f$var$LightbulbIcon.displayName = "LightbulbIcon";
var $b35d164c36c1b05f$var$_default = module.exports.default = $b35d164c36c1b05f$var$LightbulbIcon;

});

parcelRegister("iThfY", function(module, exports) {

$parcel$export(module.exports, "CustomerDetailsStats", function () { return $b645e199078d01fe$export$60ec57d65c4d2d2b; });
/* customer-details-stats.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $5ohHq = parcelRequire("5ohHq");
const $b645e199078d01fe$var$containerStyle = null;
const $b645e199078d01fe$var$horizontalContainerWithThreeStatsStyle = null;
const $b645e199078d01fe$var$statsContainerStyle = null;
const $b645e199078d01fe$var$statStyle = null;
const $b645e199078d01fe$var$statTextStyle = null;
const $b645e199078d01fe$var$horizontalStatStyle = null;
const $b645e199078d01fe$var$horizontalStatTextStyle = null;
const $b645e199078d01fe$var$layoutStyle = null;
const $b645e199078d01fe$var$oneStatDesktopStyle = null; // Stat number color to be changed in the future to be dynamic based on the page-level accent color
const $b645e199078d01fe$var$isEmptyStats = (currentObject)=>JSON.stringify(currentObject) === "{}";
const $b645e199078d01fe$export$60ec57d65c4d2d2b = ({ title: title, stats: stats })=>{
    if (!stats || (stats === null || stats === void 0 ? void 0 : stats.every($b645e199078d01fe$var$isEmptyStats))) return null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1h6o _1bsb1osq _1wpz1h6o"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_2rkovwyg _1wpz1h6o _11q71rga _18zrxy5q _1e0c1txw _2lx21bp4 _zulp1ejb _1rjcxy5q _1bhl1ejb _2osnpxbi",
                (stats === null || stats === void 0 ? void 0 : stats.length) === 1 && "_glte12it _xtn71wug",
                (stats === null || stats === void 0 ? void 0 : stats.length) === 3 && "_glteqciz _u5ggze3t _xtn7ukr8"
            ]),
            style: {
                "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card")),
                "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
            },
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: "eyebrow-md",
                    role: "heading",
                    "aria-level": 2,
                    children: title
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx2vrvc _zulpxy5q _2osn1ejb _1gde1bp4 _8164pxbi"
                    ]),
                    children: stats === null || stats === void 0 ? void 0 : stats.map((stat, idx)=>{
                        return /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, {
                            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_1e0c1txw _1wpz1fhb _16jlkb7n _i0dlidpf _2lx21bp4",
                                    (stats === null || stats === void 0 ? void 0 : stats.length) < 3 && "_1inivrvc _pdlmxy5q"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                        className: (0, $esG4f.default)([
                                            "_1wpz1fhb _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                            (stats === null || stats === void 0 ? void 0 : stats.length) < 3 && "_cdjm1h6o",
                                            "stat-sm"
                                        ]),
                                        children: stat === null || stat === void 0 ? void 0 : stat.stat
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                        className: (0, $esG4f.default)([
                                            "_1wpz1fhb _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                            (stats === null || stats === void 0 ? void 0 : stats.length) < 3 && "_cdjm1h6o",
                                            "body-md"
                                        ]),
                                        children: stat === null || stat === void 0 ? void 0 : stat.statDescription
                                    })
                                ]
                            })
                        }, idx);
                    })
                })
            ]
        })
    });
};

});

parcelRegister("hWh1T", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd7e8572b743336ba9352499cfa665f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $035eca9539192339$var$_react = $035eca9539192339$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $035eca9539192339$var$_baseNew = $035eca9539192339$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $035eca9539192339$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $035eca9539192339$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $035eca9539192339$var$_react.default.createElement($035eca9539192339$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$035eca9539192339$var$ArrowUpIcon.displayName = "ArrowUpIcon";
var $035eca9539192339$var$_default = module.exports.default = $035eca9539192339$var$ArrowUpIcon;

});

parcelRegister("fdTrW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2fb18bc89cea9c558386c877fcbee03e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b153150c5401be7a$var$_react = $b153150c5401be7a$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $b153150c5401be7a$var$_baseNew = $b153150c5401be7a$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $b153150c5401be7a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartTrendUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Upward trending data; Trend charts; Reports in Jira; Sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b153150c5401be7a$var$ChartTrendUpIcon = (props)=>/*#__PURE__*/ $b153150c5401be7a$var$_react.default.createElement($b153150c5401be7a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M15 7.5h-1.5V5.56L9.78 9.28a.75.75 0 0 1-1.06 0L7.25 7.81l-2.22 2.22-1.06-1.06 2.75-2.75.056-.052a.75.75 0 0 1 1.004.052l1.47 1.47 3.19-3.19H10.5V3h3.75a.75.75 0 0 1 .75.75z"/>`
    }, props));
$b153150c5401be7a$var$ChartTrendUpIcon.displayName = "ChartTrendUpIcon";
var $b153150c5401be7a$var$_default = module.exports.default = $b153150c5401be7a$var$ChartTrendUpIcon;

});

parcelRegister("dsYmM", function(module, exports) {

$parcel$export(module.exports, "RovoIcon", function () { return $3c36c2c0278568bb$export$e23ae35269442b4f; });
// Copy of search-ai/src/v2/common/ui/assets/Rovo.svg

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
const $3c36c2c0278568bb$export$e23ae35269442b4f = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", (0, $6iHNw._)((0, $7Knp0._)({
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M8.96666 0.28204C9.66095 -0.100922 10.5084 -0.0938864 11.197 0.303146L16.6126 3.42764L17.8968 4.16857C18.598 4.57283 19.032 5.32283 19.032 6.1308V13.8618C19.032 14.6729 18.6006 15.4196 17.8973 15.8237L12.8611 18.7293C12.8721 18.6984 12.8826 18.6672 12.8926 18.6358C12.9861 18.3462 13.0357 18.0401 13.0357 17.7272V9.99628C13.0357 8.93422 12.4704 7.95482 11.5484 7.425L10.6181 6.88854L7.79413 5.25997V2.26531C7.79413 2.02934 7.83064 1.79883 7.89972 1.58062C8.06955 1.05249 8.43078 0.595295 8.92495 0.309889L8.92645 0.309025C8.94061 0.300851 8.95409 0.291787 8.96666 0.28204Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M7.26173 1.27069L2.22547 4.17636C1.5222 4.5804 1.09082 5.32709 1.09082 6.13826V13.8692C1.09082 14.6772 1.52475 15.4271 2.22593 15.8314L3.42002 16.5203L8.9258 19.6969C9.61444 20.0939 10.4619 20.1009 11.1561 19.718C11.1687 19.7082 11.1821 19.6992 11.1963 19.6911C11.691 19.4058 12.0528 18.9485 12.2229 18.4201C12.2921 18.2017 12.3287 17.9709 12.3287 17.7347V14.7401L9.41444 13.0594L8.57469 12.5752C7.65284 12.0453 7.08715 11.0657 7.08715 10.0037V2.27277C7.08715 1.96035 7.13657 1.65469 7.2298 1.36539C7.23992 1.33362 7.25057 1.30205 7.26173 1.27069Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.41444 13.0594L3.42002 16.5203L2.22593 15.8314C1.52475 15.4271 1.09082 14.6772 1.09082 13.8692V6.13826C1.09082 5.32709 1.5222 4.5804 2.22547 4.17636L7.26173 1.27069C7.25057 1.30205 7.23992 1.33362 7.2298 1.36539C7.13657 1.65469 7.08715 1.96035 7.08715 2.27277V10.0037C7.08715 11.0657 7.65284 12.0453 8.57469 12.5752L9.41444 13.0594Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.6181 6.88854L7.79413 5.25997V2.26531C7.79413 2.02934 7.83064 1.79883 7.89972 1.58062C8.06955 1.05249 8.43078 0.595295 8.92495 0.309889L8.92645 0.309025C8.94061 0.300851 8.95409 0.291787 8.96666 0.28204C9.66095 -0.100922 10.5084 -0.0938864 11.197 0.303146L16.6126 3.42764L10.6181 6.88854Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.8968 4.16857L16.6126 3.42764L10.6181 6.88854L11.5484 7.425C12.4704 7.95482 13.0357 8.93422 13.0357 9.99628V17.7272C13.0357 18.0401 12.9861 18.3462 12.8926 18.6358C12.8826 18.6672 12.8721 18.6984 12.8611 18.7293L17.8973 15.8237C18.6006 15.4196 19.032 14.6729 19.032 13.8618V6.1308C19.032 5.32283 18.598 4.57283 17.8968 4.16857Z",
                fill: "#AF59E1"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.41444 13.0594L3.42002 16.5203L8.9258 19.6969C9.61444 20.0939 10.4619 20.1009 11.1561 19.718C11.1687 19.7082 11.1821 19.6992 11.1963 19.6911C11.691 19.4058 12.0528 18.9485 12.2229 18.4201C12.2921 18.2017 12.3287 17.9709 12.3287 17.7347V14.7401L9.41444 13.0594Z",
                fill: "#6A9A23"
            })
        ]
    }));
};

});

parcelRegister("1419P", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("5tOAJ")).default; });

var $5tOAJ = parcelRequire("5tOAJ");

});
parcelRegister("5tOAJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51ad7e783341a3f6$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $6N99x = parcelRequire("6N99x");
const $51ad7e783341a3f6$var$UniformBannerAlert = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6N99x.BannerAlert), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        dataEventProps: {
            "data-product-key": "uniform",
            "data-event-component": "linkButton",
            "data-event-container": "bannerAlert",
            "data-event": "clicked"
        }
    }));
};
var $51ad7e783341a3f6$export$2e2bcd8739ae039 = $51ad7e783341a3f6$var$UniformBannerAlert;

});


parcelRegister("54jXi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("fHStO")).default; });

var $fHStO = parcelRequire("fHStO");

});
parcelRegister("fHStO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e638ba4003f2be17$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $3FBn4 = parcelRequire("3FBn4");

var $lbVpk = parcelRequire("lbVpk");
const $e638ba4003f2be17$var$UniformButton = (props)=>{
    const localizedHref = (0, $3FBn4.useLocalizedHref)(props.href);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lbVpk.Button), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        href: localizedHref,
        dataEventProps: {
            "data-product-key": "uniform",
            "data-event-component": "linkButton",
            "data-event-container": "button",
            "data-event": "clicked"
        },
        children: props.text
    }));
};
var $e638ba4003f2be17$export$2e2bcd8739ae039 = $e638ba4003f2be17$var$UniformButton;

});


parcelRegister("gtQwZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $359d438096babc01$export$2e2bcd8739ae039; });
/* hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $lbVpk = parcelRequire("lbVpk");

var $c4STr = parcelRequire("c4STr");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");
const $359d438096babc01$export$887967f05dc521ae = (_param)=>{
    var { layout: layout = "image-right" } = _param, props = (0, $akGnX._)(_param, [
        "layout"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        style: {
            "--background-color": `${props.backgroundColor ? (0, $5ohHq.wacToken)(props.backgroundColor) : "transparent"}`
        },
        className: (0, $esG4f.default)([
            "_11q76ulk"
        ]),
        children: layout === "image-both" ? /*#__PURE__*/ (0, $loA2J.jsx)($359d438096babc01$var$HeroBothImages, (0, $7Knp0._)({
            layout: layout
        }, props)) : /*#__PURE__*/ (0, $loA2J.jsx)($359d438096babc01$var$HeroOneImage, (0, $7Knp0._)({
            layout: layout
        }, props))
    });
};
var $359d438096babc01$export$2e2bcd8739ae039 = $359d438096babc01$export$887967f05dc521ae;
const $359d438096babc01$var$DARK_BKGD_COLORS = [
    "color.primary.black"
];
const $359d438096babc01$var$HeadingContent = ({ heading: heading, subheading: subheading, callToActionProps: callToActionProps, size: size = "regular", backgroundColor: backgroundColor })=>{
    const _ref = callToActionProps !== null && callToActionProps !== void 0 ? callToActionProps : {}, { text: buttonText } = _ref, buttonProps = (0, $akGnX._)(_ref, [
        "text"
    ]);
    const isLarge = size === "large";
    const useLightText = backgroundColor ? $359d438096babc01$var$DARK_BKGD_COLORS.includes(backgroundColor) : false;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                style: {
                    color: useLightText ? (0, $5ohHq.wacToken)("color.neutral.light0") : "inherit"
                },
                className: (0, $esG4f.default)([
                    "_18s8ze3t",
                    isLarge ? "superhero" : undefined
                ]),
                children: heading
            }),
            subheading && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_6rthze3t",
                    isLarge ? "body-lg" : "body-md"
                ]),
                style: {
                    color: useLightText ? (0, $5ohHq.wacToken)("color.neutral.light0") : "inherit"
                },
                children: subheading
            }),
            buttonText && buttonProps && /*#__PURE__*/ (0, $loA2J.jsx)((0, $lbVpk.Button), (0, $6iHNw._)((0, $7Knp0._)({}, buttonProps), {
                size: "large",
                className: (0, $esG4f.default)([
                    "_1pfhxy5q"
                ]),
                children: buttonText
            }))
        ]
    });
};
const $359d438096babc01$var$HeroOneImage = (_param)=>{
    var { layout: layout = "image-right", imageProps: imageProps } = _param, props = (0, $akGnX._)(_param, [
        "layout",
        "imageProps"
    ]);
    var _imageProps_alt;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
        layout: "12",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1e0c11p5 _zulp1ejb _1rjc1jfw _y3gn1h6o _4cvr1h6o _1j8bwxkt _lagd18l3 _19wgxy5q _uj6kv2br _1ooboahv _1s0lxncg"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        layout === "image-left" && "_1b1qcs5v"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)($359d438096babc01$var$HeadingContent, (0, $7Knp0._)({}, props))
                }),
                imageProps && /*#__PURE__*/ (0, $loA2J.jsx)((0, $c4STr.Image), {
                    maxPossibleWidth: 700,
                    src: imageProps.src,
                    alt: (_imageProps_alt = imageProps.alt) !== null && _imageProps_alt !== void 0 ? _imageProps_alt : "",
                    loading: "eager",
                    width: imageProps.width,
                    height: imageProps.height
                })
            ]
        })
    });
};
const $359d438096babc01$var$gridStyle = null;
const $359d438096babc01$var$headingStyle = null;
const $359d438096babc01$var$imageStartStyle = null;
const $359d438096babc01$var$bodyStyle = null;
const $359d438096babc01$var$buttonStyle = null; /*
                          This is an experimental start to support the needs of the Hero variation with images on the sides, primary content centered
                          Initial support is seens on Product enterprise pages (such as /software/jira/enterprise) as served by WAC Authoring Engine
                          
                          TODO: We need to understand the levels of configurability desired/needed to support a variety of use cases, collab with design.
                            Currently it is very tailored to the aforementioned enterprise experience
                          */ 
const $359d438096babc01$var$HeroBothImages = (_param)=>{
    var { imageProps: imageProps, secondaryImageProps: secondaryImageProps } = _param, props = (0, $akGnX._)(_param, [
        "imageProps",
        "secondaryImageProps"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1reo15vq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
            layout: "12",
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_uaqo1x3a _13j917im",
                    "_kqswh2mm _1e0c11p5 _10fp1h6o _y3gn1h6o _4cvr1h6o _6a6z1h6o _1rjc1jfw _14b51ssb _su07u2gc _1ooboahv _1s0lxncg _bxthb3bt _t4hxstnw _1yp51osq _1bpvsmen _brhgmgnk _5kbx1f51 _1gg8w2la _n4lfidpf _1nls12it _14xsidpf _16bh12it _1z0y9by0 _ixsu1osq _a6uwb3bt _dbttstnw _83tk1wn5 _10wjmgnk _tzs91f51 _wi3i1048 _1x65idpf _oppa12it _1ohy1kly _nd8fidpf _1yam12it _ugza1kly _mlxy9by0 _k4z51osq _xcpbpwvu"
                ]),
                style: {
                    "--_1thiznr": (0, $43MIc.default)(imageProps ? `url(${imageProps.src})` : "none"),
                    "--_c31b9r": (0, $43MIc.default)(secondaryImageProps ? `url(${secondaryImageProps.src})` : "none")
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)($359d438096babc01$var$HeadingContent, (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                    size: "regular"
                }))
            })
        })
    });
};
const $359d438096babc01$var$gridTwoImagesStyle = null;

});

parcelRegister("7vkxP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("6q68w")).default; });

var $6q68w = parcelRequire("6q68w");

});
parcelRegister("6q68w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94975d69a8f24321$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $1UUq1 = parcelRequire("1UUq1");

var $8lB1y = parcelRequire("8lB1y");

var $3FBn4 = parcelRequire("3FBn4");
const $94975d69a8f24321$var$getBodyText = (props)=>{
    if (!props.body && !props.richText) return undefined;
    if (props.richText) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lB1y.RichTextComponent), {
        text: props.richText
    });
    return props.body;
};
const $94975d69a8f24321$var$UniformCard = (props)=>{
    var _props_linkUrl;
    var _props_linkUrl_toString;
    const localizedHref = (0, $3FBn4.useLocalizedHref)((_props_linkUrl_toString = (_props_linkUrl = props.linkUrl) === null || _props_linkUrl === void 0 ? void 0 : _props_linkUrl.toString()) !== null && _props_linkUrl_toString !== void 0 ? _props_linkUrl_toString : "");
    var _props_imageAlt;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Card), {
        align: props.alignment,
        orientation: props.orientation,
        columns: props.columns,
        background: props.background,
        eyebrow: props.eyebrow ? props.eyebrow : undefined,
        logo: props.logo,
        title: props.title ? props.title : undefined,
        titleAs: props.titleAs,
        body: $94975d69a8f24321$var$getBodyText(props),
        callToAction: props.linkUrl && props.linkText ? {
            text: props.linkText,
            href: localizedHref,
            dataEventProps: {
                "data-product-key": "uniform",
                "data-event-component": "linkButton",
                "data-event-container": "card",
                "data-event": "clicked"
            }
        } : undefined,
        image: props.imageUrl ? {
            image: {
                src: props.imageUrl,
                alt: (_props_imageAlt = props.imageAlt) !== null && _props_imageAlt !== void 0 ? _props_imageAlt : ""
            }
        } : undefined,
        icon: props.iconUrl ? {
            linkedIcon: {
                url: props.iconUrl,
                size: props.iconSize
            }
        } : undefined,
        spotIllustrationUrl: props.spotIllustrationUrl
    });
};
var $94975d69a8f24321$export$2e2bcd8739ae039 = $94975d69a8f24321$var$UniformCard;

});


parcelRegister("haYnf", function(module, exports) {
$parcel$export(module.exports, "UniformColumnLayout", function () { return (parcelRequire("gVN7C")).UniformColumnLayout; });
$parcel$export(module.exports, "UniformSubColumnLayout", function () { return (parcelRequire("gVN7C")).UniformSubColumnLayout; });
parcelRequire("gVN7C");

});
parcelRegister("gVN7C", function(module, exports) {

$parcel$export(module.exports, "UniformColumnLayout", function () { return $cf835c6cfdad349b$export$23133ddca0202abb; });
$parcel$export(module.exports, "UniformSubColumnLayout", function () { return $cf835c6cfdad349b$export$8807233e43f557a9; });
/* column-layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $aiugz = parcelRequire("aiugz");
const $cf835c6cfdad349b$var$baseStyle = null;
const $cf835c6cfdad349b$var$fullWidthStyles = null;
const $cf835c6cfdad349b$var$layout10 = null;
const $cf835c6cfdad349b$var$layout8 = null; // For 8-4 the following is equivalent to having a 12 column grid
// where the first child is `gridColumn: 1 / span 8` and the second is `9 / -1`
const $cf835c6cfdad349b$var$layout84 = null;
const $cf835c6cfdad349b$var$layout48 = null;
const $cf835c6cfdad349b$var$layout93 = null;
const $cf835c6cfdad349b$var$layout39 = null;
const $cf835c6cfdad349b$var$layout66 = null;
const $cf835c6cfdad349b$var$layout75 = null;
const $cf835c6cfdad349b$var$layout57 = null;
const $cf835c6cfdad349b$var$layout336 = null;
const $cf835c6cfdad349b$var$layout633 = null;
const $cf835c6cfdad349b$var$layout444 = null;
const $cf835c6cfdad349b$var$layout3333 = null;
const $cf835c6cfdad349b$var$layout222222 = null;
const $cf835c6cfdad349b$var$layoutArticle = null;
const $cf835c6cfdad349b$var$resetListStyles = null;
const $cf835c6cfdad349b$var$slotWrapper = ({ items: items })=>{
    return items.map((element, index)=>{
        return /*#__PURE__*/ (0, $loA2J.jsx)("li", {
            children: element
        }, index);
    });
}; // Compiled styling requires complex set of choices
const $cf835c6cfdad349b$export$23133ddca0202abb = ({ layout: layout = "12", paddingTopv2: paddingTopv2, paddingBottomv2: paddingBottomv2, verticalAlignment: verticalAlignment = "normal", renderAsList: renderAsList, children: children // eslint-disable-next-line complexity
 })=>{
    var _paddingTopv2_mobile, _paddingTopv2_tablet, _ref, // @ts-ignore
    _paddingTopv2_desktop, _ref1, _ref2;
    const paddingTopObject = {
        // @ts-ignore
        mobile: (_paddingTopv2_mobile = paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.mobile) !== null && _paddingTopv2_mobile !== void 0 ? _paddingTopv2_mobile : "0",
        // @ts-ignore
        tablet: (_ref = (_paddingTopv2_tablet = paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.tablet) !== null && _paddingTopv2_tablet !== void 0 ? _paddingTopv2_tablet : paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.mobile) !== null && _ref !== void 0 ? _ref : "0",
        desktop: (_ref2 = (_ref1 = (_paddingTopv2_desktop = paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.desktop) !== null && _paddingTopv2_desktop !== void 0 ? _paddingTopv2_desktop : // @ts-ignore
        paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.tablet) !== null && _ref1 !== void 0 ? _ref1 : // @ts-ignore
        paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.mobile) !== null && _ref2 !== void 0 ? _ref2 : "0"
    };
    var _paddingBottomv2_mobile, _paddingBottomv2_tablet, _ref3, // @ts-ignore
    _paddingBottomv2_desktop, _ref4, _ref5;
    const paddingBottomObject = {
        // @ts-ignore
        mobile: (_paddingBottomv2_mobile = paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.mobile) !== null && _paddingBottomv2_mobile !== void 0 ? _paddingBottomv2_mobile : "0",
        // @ts-ignore
        tablet: (_ref3 = (_paddingBottomv2_tablet = paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.tablet) !== null && _paddingBottomv2_tablet !== void 0 ? _paddingBottomv2_tablet : paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.mobile) !== null && _ref3 !== void 0 ? _ref3 : "0",
        desktop: (_ref5 = (_ref4 = (_paddingBottomv2_desktop = paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.desktop) !== null && _paddingBottomv2_desktop !== void 0 ? _paddingBottomv2_desktop : // @ts-ignore
        paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.tablet) !== null && _ref4 !== void 0 ? _ref4 : // @ts-ignore
        paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.mobile) !== null && _ref5 !== void 0 ? _ref5 : "0"
    };
    const paddingStyles = null;
    const alignmentStyles = null;
    const Container = renderAsList !== null && renderAsList !== void 0 ? renderAsList : "div";
    return /*#__PURE__*/ (0, $loA2J.jsx)(Container, {
        className: (0, $esG4f.default)([
            renderAsList && "_qtt815ep _18zridpf _1e7yidpf _go4ridpf _omn3idpf _s22yidpf _1eg6idpf _1xnlidpf _53osidpf _138kidpf",
            "_1e0c11p5 _vchhusvi _zulp14hz _1bsb1osq _1dsl1tcg _13ltwklj _1vsw1vi7 _99hyidpf",
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _bozgzwfg _y4tizwfg _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _10jxzqdx",
            "_1q51aqwo _85i51jtx _1waf136c _1yd317nz _26vx1ut2 _40tu7014",
            "_4cvr1ekp",
            layout === "10" && "_1j8bcx6w _klsv179g",
            layout === "8" && "_1j8bcx6w _klsveqnf",
            layout === "8-4" && "_19smexmx _1j8b1890",
            layout === "4-8" && "_19smexmx _1j8bi0c8",
            layout === "9-3" && "_1i4gqiai _1j8b1i9f",
            layout === "3-9" && "_1i4gqiai _1j8bvfzv",
            layout === "7-5" && "_13wb12kr _1j8bkxgm",
            layout === "5-7" && "_13wb12kr _1j8bdq95",
            layout === "6-6" && "_1j8bwxkt",
            layout === "4-4-4" && "_1j8b16hb",
            layout === "3-3-3-3" && "_1j8bwxkt _1rqt1ezz",
            layout === "2-2-2-2-2-2" && "_yv0ewxkt _1j8b1g7m",
            layout === "6-3-3" && "_1i4gqiai _1j8b1jr3",
            layout === "3-3-6" && "_1i4gqiai _1j8bmdi6",
            layout === "article" && "_z9r4exmx _1rqti0c8"
        ]),
        style: {
            "--_x9jeny": (0, $43MIc.default)("var(--ds-space-" + paddingTopObject.mobile + ")"),
            "--_15jk1js": (0, $43MIc.default)("var(--ds-space-" + paddingBottomObject.mobile + ")"),
            "--_d48zib": (0, $43MIc.default)("var(--ds-space-" + paddingTopObject.tablet + ")"),
            "--_8w0mk6": (0, $43MIc.default)("var(--ds-space-" + paddingBottomObject.tablet + ")"),
            "--_1l28e2h": (0, $43MIc.default)("var(--ds-space-" + paddingTopObject.desktop + ")"),
            "--_14v99j0": (0, $43MIc.default)("var(--ds-space-" + paddingBottomObject.desktop + ")"),
            "--_1813xhc": (0, $43MIc.default)(verticalAlignment)
        },
        children: children ? children : /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
            name: "content",
            wrapperComponent: renderAsList ? $cf835c6cfdad349b$var$slotWrapper : undefined
        })
    });
}; // Compiled styling requires complex set of choices
const $cf835c6cfdad349b$export$8807233e43f557a9 = ({ layout: layout = "12", paddingTopv2: paddingTopv2, paddingBottomv2: paddingBottomv2, verticalAlignment: verticalAlignment = "normal", renderAsList: renderAsList, children: children // eslint-disable-next-line complexity
 })=>{
    var _paddingTopv2_mobile, _paddingTopv2_tablet, _ref, // @ts-ignore
    _paddingTopv2_desktop, _ref1, _ref2;
    const paddingTopObject = {
        // @ts-ignore
        mobile: (_paddingTopv2_mobile = paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.mobile) !== null && _paddingTopv2_mobile !== void 0 ? _paddingTopv2_mobile : "0",
        // @ts-ignore
        tablet: (_ref = (_paddingTopv2_tablet = paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.tablet) !== null && _paddingTopv2_tablet !== void 0 ? _paddingTopv2_tablet : paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.mobile) !== null && _ref !== void 0 ? _ref : "0",
        desktop: (_ref2 = (_ref1 = (_paddingTopv2_desktop = paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.desktop) !== null && _paddingTopv2_desktop !== void 0 ? _paddingTopv2_desktop : // @ts-ignore
        paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.tablet) !== null && _ref1 !== void 0 ? _ref1 : // @ts-ignore
        paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.mobile) !== null && _ref2 !== void 0 ? _ref2 : "0"
    };
    var _paddingBottomv2_mobile, _paddingBottomv2_tablet, _ref3, // @ts-ignore
    _paddingBottomv2_desktop, _ref4, _ref5;
    const paddingBottomObject = {
        // @ts-ignore
        mobile: (_paddingBottomv2_mobile = paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.mobile) !== null && _paddingBottomv2_mobile !== void 0 ? _paddingBottomv2_mobile : "0",
        // @ts-ignore
        tablet: (_ref3 = (_paddingBottomv2_tablet = paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.tablet) !== null && _paddingBottomv2_tablet !== void 0 ? _paddingBottomv2_tablet : paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.mobile) !== null && _ref3 !== void 0 ? _ref3 : "0",
        // @ts-ignore
        desktop: (_ref5 = (_ref4 = (_paddingBottomv2_desktop = paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.desktop) !== null && _paddingBottomv2_desktop !== void 0 ? _paddingBottomv2_desktop : // @ts-ignore
        paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.tablet) !== null && _ref4 !== void 0 ? _ref4 : // @ts-ignore
        paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.mobile) !== null && _ref5 !== void 0 ? _ref5 : "0"
    };
    const paddingStyles = null;
    const alignmentStyles = null;
    const Container = renderAsList !== null && renderAsList !== void 0 ? renderAsList : "div";
    return /*#__PURE__*/ (0, $loA2J.jsx)(Container, {
        className: (0, $esG4f.default)([
            "_1e0c11p5 _vchhusvi _zulp14hz _1bsb1osq _1dsl1tcg _13ltwklj _1vsw1vi7 _99hyidpf",
            "_1q51aqwo _85i51jtx _1waf136c _1yd317nz _26vx1ut2 _40tu7014",
            "_4cvr1ekp",
            renderAsList && "_qtt815ep _18zridpf _1e7yidpf _go4ridpf _omn3idpf _s22yidpf _1eg6idpf _1xnlidpf _53osidpf _138kidpf",
            layout === "10" && "_1j8bcx6w _klsv179g",
            layout === "8" && "_1j8bcx6w _klsveqnf",
            layout === "8-4" && "_19smexmx _1j8b1890",
            layout === "4-8" && "_19smexmx _1j8bi0c8",
            layout === "9-3" && "_1i4gqiai _1j8b1i9f",
            layout === "3-9" && "_1i4gqiai _1j8bvfzv",
            layout === "7-5" && "_13wb12kr _1j8bkxgm",
            layout === "5-7" && "_13wb12kr _1j8bdq95",
            layout === "6-6" && "_1j8bwxkt",
            layout === "4-4-4" && "_1j8b16hb",
            layout === "3-3-3-3" && "_1j8bwxkt _1rqt1ezz",
            layout === "2-2-2-2-2-2" && "_yv0ewxkt _1j8b1g7m",
            layout === "6-3-3" && "_1i4gqiai _1j8b1jr3",
            layout === "3-3-6" && "_1i4gqiai _1j8bmdi6"
        ]),
        style: {
            "--_x9jeny": (0, $43MIc.default)("var(--ds-space-" + paddingTopObject.mobile + ")"),
            "--_15jk1js": (0, $43MIc.default)("var(--ds-space-" + paddingBottomObject.mobile + ")"),
            "--_d48zib": (0, $43MIc.default)("var(--ds-space-" + paddingTopObject.tablet + ")"),
            "--_8w0mk6": (0, $43MIc.default)("var(--ds-space-" + paddingBottomObject.tablet + ")"),
            "--_1l28e2h": (0, $43MIc.default)("var(--ds-space-" + paddingTopObject.desktop + ")"),
            "--_14v99j0": (0, $43MIc.default)("var(--ds-space-" + paddingBottomObject.desktop + ")"),
            "--_1813xhc": (0, $43MIc.default)(verticalAlignment)
        },
        children: children ? children : /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
            name: "content",
            wrapperComponent: renderAsList ? $cf835c6cfdad349b$var$slotWrapper : undefined
        })
    });
}; // Both components are exported as named exports above

});


parcelRegister("dX6Xs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("jgCjv")).default; });

var $jgCjv = parcelRequire("jgCjv");

});
parcelRegister("jgCjv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26db6e668dcd1535$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $2bAHw = parcelRequire("2bAHw");

var $iThfY = parcelRequire("iThfY");
const $26db6e668dcd1535$export$760d8d36b06866af = (props)=>{
    const statProps = (0, $7Knp0._)({}, props);
    statProps.stats = (0, $2bAHw.flattenValues)(props.stats);
    return statProps;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $26db6e668dcd1535$var$UniformCustomerStat = (props)=>{
    const statProps = $26db6e668dcd1535$export$760d8d36b06866af(props);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iThfY.CustomerDetailsStats), (0, $7Knp0._)({}, statProps));
};
var $26db6e668dcd1535$export$2e2bcd8739ae039 = $26db6e668dcd1535$var$UniformCustomerStat;

});


parcelRegister("e992t", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("8fNuT")).default; });

var $8fNuT = parcelRequire("8fNuT");

});
parcelRegister("8fNuT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2094b45cba049d08$export$2e2bcd8739ae039; });
/* hero-intro.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
const $2094b45cba049d08$var$UniformHeroIntro = ({ title: title, subtitle: subtitle, alignment: alignment })=>{
    const heroContainer = null;
    const textCss = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_y3gnoues _yv0ecx6w _1e0c11p5 _gy1p1tcg _1rqtaigu _ikjdzwfg"
        ]),
        style: {
            "--_1v0xqnb": (0, $43MIc.default)(alignment)
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                className: (0, $esG4f.default)([
                    "_6rthidpf _yyhy13k5 _1e3c9kbg"
                ]),
                style: {
                    "--_1gb0l6x": (0, $43MIc.default)(alignment == "center" ? "2" : "1")
                },
                children: title
            }),
            subtitle && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_6rthidpf _yyhy13k5 _1e3c9kbg",
                    "body-lg"
                ]),
                style: {
                    "--_1gb0l6x": (0, $43MIc.default)(alignment == "center" ? "2" : "1")
                },
                children: subtitle
            })
        ]
    });
};
var $2094b45cba049d08$export$2e2bcd8739ae039 = $2094b45cba049d08$var$UniformHeroIntro;

});


parcelRegister("9WxMx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("ipijV")).default; });

var $ipijV = parcelRequire("ipijV");

});
parcelRegister("ipijV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76970d4a009ce6ab$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $aiugz = parcelRequire("aiugz");

var $8jdfl = parcelRequire("8jdfl");

var $j27rt = parcelRequire("j27rt");

var $9iWJ8 = parcelRequire("9iWJ8");

var $1MbAx = parcelRequire("1MbAx");
const $76970d4a009ce6ab$var$UniformExperiment = (props)=>{
    var _Object_entries_find;
    const { experimentId: experimentId, override: override, postExperimentationMode: postExperimentationMode } = props;
    const context = (0, $j27rt.useWAEContextSafe)();
    if (postExperimentationMode) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: experimentId,
        group: "Test",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
            name: "treatment"
        })
    });
    const experiment = (_Object_entries_find = Object.entries((0, $9iWJ8.experiments)).find(([, value])=>value.experimentName === experimentId)) === null || _Object_entries_find === void 0 ? void 0 : _Object_entries_find[1];
    if (override && (context === null || context === void 0 ? void 0 : context.wacEnvironment) !== "production") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
        name: override
    });
    if (!experiment) return (context === null || context === void 0 ? void 0 : context.wacEnvironment) === "production" ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
        name: "control"
    }) : /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $8jdfl.ManifestErrorMessage), {
                id: experimentId
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
                name: "control"
            })
        ]
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const experimentStatus = (0, $9iWJ8.useExperiment)(experiment);
    const showTreatment = experimentStatus.type === "enrolled" && experimentStatus.value;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
        name: showTreatment ? "treatment" : "control"
    });
};
var $76970d4a009ce6ab$export$2e2bcd8739ae039 = $76970d4a009ce6ab$var$UniformExperiment;

});
parcelRegister("8jdfl", function(module, exports) {

$parcel$export(module.exports, "ManifestErrorMessage", function () { return $641d3f539f73a96d$export$702dc26c1a322512; });

var $loA2J = parcelRequire("loA2J");

var $cUvUr = parcelRequire("cUvUr");
const $641d3f539f73a96d$export$702dc26c1a322512 = ({ id: id })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: id.length === 0 ? null : /*#__PURE__*/ (0, $loA2J.jsx)((0, $cUvUr.default), {
            appearance: "error",
            isDismissible: true,
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("strong", {
                        children: "Manifest entry not found for:"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $loA2J.jsx)("code", {
                        children: id
                    }),
                    ". Rendering control slot."
                ]
            })
        })
    });
};

});



parcelRegister("gp86Z", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("hhL3A")).default; });

var $hhL3A = parcelRequire("hhL3A");

});
parcelRegister("hhL3A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd5d4138f36a46c2$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $aiugz = parcelRequire("aiugz");

var $8jdfl = parcelRequire("8jdfl");

var $j27rt = parcelRequire("j27rt");

var $gAJUc = parcelRequire("gAJUc");
const $fd5d4138f36a46c2$var$UniformFeatureGate = (props)=>{
    var _Object_entries_find;
    const { featureGateId: featureGateId, override: override } = props;
    const context = (0, $j27rt.useWAEContextSafe)();
    const featureGate = (_Object_entries_find = Object.entries((0, $gAJUc.featureFlags)).find(([, value])=>value.featureFlagName === featureGateId)) === null || _Object_entries_find === void 0 ? void 0 : _Object_entries_find[1];
    if (override && (context === null || context === void 0 ? void 0 : context.wacEnvironment) !== "production") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
        name: override
    });
    if (!featureGate) return (context === null || context === void 0 ? void 0 : context.wacEnvironment) === "production" ? null : /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $8jdfl.ManifestErrorMessage), {
                id: featureGateId
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
                name: "control"
            })
        ]
    });
    const showTreatment = (0, $gAJUc.checkFeatureFlagGate)(featureGate);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
        name: showTreatment ? "treatment" : "control"
    });
};
var $fd5d4138f36a46c2$export$2e2bcd8739ae039 = $fd5d4138f36a46c2$var$UniformFeatureGate;

});


parcelRegister("gMNh2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("8TUqr")).default; });

var $8TUqr = parcelRequire("8TUqr");

});
parcelRegister("8TUqr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70d47a54af07b35a$export$2e2bcd8739ae039; });

var $kex29 = parcelRequire("kex29");
var $70d47a54af07b35a$export$2e2bcd8739ae039 = (0, $kex29.GlobalFooter);

});


parcelRegister("l0zDw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("3qApo")).default; });

var $3qApo = parcelRequire("3qApo");

});
parcelRegister("3qApo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4d70652145ea3ff$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $6NDAm = parcelRequire("6NDAm");
const $a4d70652145ea3ff$var$UniformGlobalNav = ({ productKey: // This productKey is used for UFO instrumentation
// This prop is standardized to the value `uniform`
// See ldr/0018-set-standard-uniform-globalnav-productkey.md for more details
productKey = "uniform", isShowTryNowLink: isShowTryNowLink = true })=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $6NDAm.GlobalNav), {
        productKey: productKey,
        isShowTryNowLink: isShowTryNowLink
    });
var $a4d70652145ea3ff$export$2e2bcd8739ae039 = $a4d70652145ea3ff$var$UniformGlobalNav;

});


parcelRegister("4jHZw", function(module, exports) {

$parcel$export(module.exports, "useStylePropertyVariableValueFromParent", function () { return $baac376c55aaca28$export$a43348ac9682b5fa; });

var $iSvIT = parcelRequire("iSvIT");
const $baac376c55aaca28$export$a43348ac9682b5fa = (cssVariableName)=>{
    const ref = (0, $iSvIT.useRef)(null);
    const [propertyValue, setPropertyValue] = (0, $iSvIT.useState)();
    (0, $iSvIT.useEffect)(()=>{
        if (!ref.current) return;
        let element = ref.current;
        let depth = 0;
        const maxDepth = 20; // prevent infinite loops
        while(element && depth < maxDepth){
            const computedStyle = getComputedStyle(element);
            const value = computedStyle.getPropertyValue(cssVariableName).trim();
            if (value && value !== "") {
                setPropertyValue(value);
                return;
            }
            element = element.parentElement;
            depth++;
        }
        setPropertyValue(undefined);
    }, [
        cssVariableName
    ]);
    return [
        ref,
        propertyValue
    ];
};

});

parcelRegister("hS2Tl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("bEbxJ")).default; });

var $bEbxJ = parcelRequire("bEbxJ");

});
parcelRegister("bEbxJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $facb2e5cfffff962$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $gtQwZ = parcelRequire("gtQwZ");

var $3FBn4 = parcelRequire("3FBn4");
const $facb2e5cfffff962$var$UniformHeroSection = (props)=>{
    var _props_buttonHref;
    var _props_buttonHref_path;
    const localizedButtonHref = (0, $3FBn4.useLocalizedHref)((_props_buttonHref_path = (_props_buttonHref = props.buttonHref) === null || _props_buttonHref === void 0 ? void 0 : _props_buttonHref.path) !== null && _props_buttonHref_path !== void 0 ? _props_buttonHref_path : "");
    var _props_layout, _props_imageAlt;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $gtQwZ.default), {
        heading: props.heading,
        subheading: props.subheading,
        layout: (_props_layout = props.layout) !== null && _props_layout !== void 0 ? _props_layout : "image-right",
        // @ts-ignore
        backgroundColor: props.backgroundColor,
        callToActionProps: props.buttonHref && props.buttonLabel ? {
            text: props.buttonLabel,
            href: localizedButtonHref
        } : undefined,
        imageProps: props.imageUrl ? {
            src: props.imageUrl,
            alt: (_props_imageAlt = props.imageAlt) !== null && _props_imageAlt !== void 0 ? _props_imageAlt : ""
        } : undefined,
        secondaryImageProps: props.secondaryImageUrl ? {
            src: props.secondaryImageUrl,
            alt: ""
        } : undefined
    });
};
var $facb2e5cfffff962$export$2e2bcd8739ae039 = $facb2e5cfffff962$var$UniformHeroSection;

});


parcelRegister("7JHqD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("3IgE4")).default; });

var $3IgE4 = parcelRequire("3IgE4");

});
parcelRegister("3IgE4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9df49062445c098$export$2e2bcd8739ae039; });
/* horizontal-divider.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $4J1z5 = parcelRequire("4J1z5");

var $5ohHq = parcelRequire("5ohHq");
const $e9df49062445c098$var$dividerStyle = null;
const $e9df49062445c098$var$UniformHorizontalDivider = ({ lineStyle: lineStyle = "solid" })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("hr", {
        role: "presentation",
        style: {
            borderBlockStart: `1px ${lineStyle} ${(0, $5ohHq.wacToken)("color.neutral.light400")}`
        },
        className: (0, $esG4f.default)([
            "_1bsb1osq _19itglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ])
    });
};
$e9df49062445c098$var$UniformHorizontalDivider.propTypes = {
    lineStyle: (0, (/*@__PURE__*/$parcel$interopDefault($4J1z5))).string
};
var $e9df49062445c098$export$2e2bcd8739ae039 = $e9df49062445c098$var$UniformHorizontalDivider;

});


parcelRegister("e6r6l", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("l8rpb")).default; });

var $l8rpb = parcelRequire("l8rpb");

});
parcelRegister("l8rpb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a14fc0a3a762f3f$export$2e2bcd8739ae039; });
/* image.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $bhreu = parcelRequire("bhreu");
// eslint-disable-next-line complexity
const $6a14fc0a3a762f3f$var$UniformImage = ({ source: source, altText: altText = "", width: width, maxWidth: maxWidth, height: height, maxHeight: maxHeight, objectFit: objectFit, objectPosition: objectPosition, tabletWidth: tabletWidth, desktopWidth: desktopWidth, tabletHeight: tabletHeight, desktopHeight: desktopHeight, makeCircle: makeCircle = false })=>{
    const imageStyle = {
        maxWidth: maxWidth,
        maxHeight: maxHeight,
        objectFit: objectFit,
        objectPosition: objectPosition
    };
    const widthStyle = null;
    const heightStyle = null;
    const tabletWidthStyle = null;
    const desktopWidthStyle = null;
    const tabletHeightStyle = null;
    const desktopHeightStyle = null; // @ts-ignore
    const responsiveStyles = null;
    const makeCircleStyle = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: source,
            alt: altText
        },
        className: (0, $esG4f.default)([
            width && "_1bsbzdsf",
            height && "_4t3i1rot",
            tabletWidth && "_14b51mzn",
            desktopWidth && "_glte1k6c",
            tabletHeight && "_1xloa7f3",
            desktopHeight && "_165tbekw",
            makeCircle && "_2rko1ssb"
        ]),
        style: (0, $6iHNw._)((0, $7Knp0._)({}, imageStyle), {
            "--_m5r7t4": (0, $43MIc.default)(width ? width : "auto"),
            "--_mzs5ed": (0, $43MIc.default)(height ? height : "auto"),
            "--_dwkr3u": (0, $43MIc.default)(tabletWidth ? tabletWidth : "auto"),
            "--_1mc860w": (0, $43MIc.default)(desktopWidth ? desktopWidth : "auto"),
            "--_1cta8t7": (0, $43MIc.default)(tabletHeight ? tabletHeight : "auto"),
            "--_1frmj6s": (0, $43MIc.default)(desktopHeight ? desktopHeight : "auto")
        })
    });
};
var $6a14fc0a3a762f3f$export$2e2bcd8739ae039 = $6a14fc0a3a762f3f$var$UniformImage;

});


parcelRegister("4x11f", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("6wjLX")).default; });

var $6wjLX = parcelRequire("6wjLX");

});
parcelRegister("6wjLX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b643348a4469187c$export$2e2bcd8739ae039; });
/* jira-templates-tab-content-subgrid-layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $aiugz = parcelRequire("aiugz");
const $b643348a4469187c$export$2f2a2862921598f6 = ()=>{
    const renderJiraTemplatesTabContent = ({ items: items })=>{
        return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _2lx21bp4 _zulpv47k _dm2511p5 _dbjgidpf _1hvkidpf _isu4idpf _15qmidpf _oqicidpf _1rmjidpf _cjbtidpf _pnmbidpf _pdlm14hz _glte1osq _1vsw13cz _18jf188f _azss12kr _1rqt1we7"
            ]),
            children: items
        });
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
        name: "jiraTemplatesTabContent",
        wrapperComponent: renderJiraTemplatesTabContent
    });
};
var $b643348a4469187c$export$2e2bcd8739ae039 = $b643348a4469187c$export$2f2a2862921598f6;

});


parcelRegister("dFD1n", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("9KNdd")).default; });

var $9KNdd = parcelRequire("9KNdd");

});
parcelRegister("9KNdd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb3d14b85778a1e0$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $3FBn4 = parcelRequire("3FBn4");

var $9iZsm = parcelRequire("9iZsm");

var $gAJUc = parcelRequire("gAJUc");

var $1O6nN = parcelRequire("1O6nN");
const $bb3d14b85778a1e0$export$64bc9cd96d3d9a80 = (props)=>{
    let localizedHref = (0, $3FBn4.useLocalizedHref)(props.href);
    const localizedPartnerDirectoryUrl = (0, $9iZsm.useLocalizedPartnerDirectoryHref)(props.href);
    const checkGate = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwpUniformLinkLocalizePartnerDirectory);
    if (checkGate && props.href !== localizedPartnerDirectoryUrl) localizedHref = localizedPartnerDirectoryUrl;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1O6nN.Link), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        "aria-label": props.text,
        href: localizedHref,
        dataEventProps: {
            "data-product-key": "uniform",
            "data-event-component": "linkButton",
            "data-event-container": "link",
            "data-event": "clicked"
        }
    }));
};
var $bb3d14b85778a1e0$export$2e2bcd8739ae039 = $bb3d14b85778a1e0$export$64bc9cd96d3d9a80;

});


parcelRegister("hykE5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("dWM7f")).default; });

var $dWM7f = parcelRequire("dWM7f");

});
parcelRegister("dWM7f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17a81881ca6e4dbf$export$2e2bcd8739ae039; });
/* list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $aiugz = parcelRequire("aiugz");

var $4muOv = parcelRequire("4muOv");
const $17a81881ca6e4dbf$var$UniformList = ({ gap: gap = "space.100", maxHeight: maxHeight, isHorizontal: isHorizontal = false })=>{
    const spaceTokenValue = (0, $4muOv.spaceTokenValues)[gap];
    const listStyle = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21q43 _zulpfogq _c71l1nve _1reo15vq _18m915vq"
        ]),
        style: {
            "--_edet6m": (0, $43MIc.default)(isHorizontal ? "row" : "column"),
            "--_e9ez6f": (0, $43MIc.default)("var(--ds-space-" + spaceTokenValue + ")"),
            "--_6stjzx": (0, $43MIc.default)(maxHeight ? maxHeight + "px" : "none")
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
            name: "listItems"
        })
    });
};
var $17a81881ca6e4dbf$export$2e2bcd8739ae039 = $17a81881ca6e4dbf$var$UniformList;

});


parcelRegister("ee1EE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("1Yaob")).default; });

var $1Yaob = parcelRequire("1Yaob");

});
parcelRegister("1Yaob", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebf870f54152743d$export$2e2bcd8739ae039; });
/* listv2.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $aiugz = parcelRequire("aiugz");

var $62pC7 = parcelRequire("62pC7");
const $ebf870f54152743d$var$createResponsiveGapObject = (gapv2)=>{
    var _gapv2_mobile, _gapv2_tablet, _ref, _gapv2_desktop, _ref1, _ref2;
    return {
        mobile: (_gapv2_mobile = gapv2.mobile) !== null && _gapv2_mobile !== void 0 ? _gapv2_mobile : "0",
        tablet: (_ref = (_gapv2_tablet = gapv2 === null || gapv2 === void 0 ? void 0 : gapv2.tablet) !== null && _gapv2_tablet !== void 0 ? _gapv2_tablet : gapv2.mobile) !== null && _ref !== void 0 ? _ref : "0",
        desktop: (_ref2 = (_ref1 = (_gapv2_desktop = gapv2 === null || gapv2 === void 0 ? void 0 : gapv2.desktop) !== null && _gapv2_desktop !== void 0 ? _gapv2_desktop : gapv2 === null || gapv2 === void 0 ? void 0 : gapv2.tablet) !== null && _ref1 !== void 0 ? _ref1 : gapv2.mobile) !== null && _ref2 !== void 0 ? _ref2 : "0"
    };
};
const $ebf870f54152743d$var$createResponsiveOrientationObject = (orientation)=>({
        mobile: orientation.mobile || "vertical",
        tablet: orientation.tablet || orientation.mobile || "vertical",
        desktop: orientation.desktop || orientation.tablet || orientation.mobile || "vertical"
    });
const $ebf870f54152743d$var$createResponsiveWrappedChildContentObject = (wrappedChildContent)=>({
        mobile: (wrappedChildContent === null || wrappedChildContent === void 0 ? void 0 : wrappedChildContent.mobile) || "nowrap",
        tablet: (wrappedChildContent === null || wrappedChildContent === void 0 ? void 0 : wrappedChildContent.tablet) || (wrappedChildContent === null || wrappedChildContent === void 0 ? void 0 : wrappedChildContent.mobile) || "nowrap",
        desktop: (wrappedChildContent === null || wrappedChildContent === void 0 ? void 0 : wrappedChildContent.desktop) || (wrappedChildContent === null || wrappedChildContent === void 0 ? void 0 : wrappedChildContent.tablet) || (wrappedChildContent === null || wrappedChildContent === void 0 ? void 0 : wrappedChildContent.mobile) || "nowrap"
    });
const $ebf870f54152743d$var$createResponsiveJustifyContentObject = (justifyContent)=>({
        mobile: justifyContent.mobile || "flex-start",
        tablet: (justifyContent === null || justifyContent === void 0 ? void 0 : justifyContent.tablet) || (justifyContent === null || justifyContent === void 0 ? void 0 : justifyContent.mobile) || "flex-start",
        desktop: (justifyContent === null || justifyContent === void 0 ? void 0 : justifyContent.desktop) || (justifyContent === null || justifyContent === void 0 ? void 0 : justifyContent.tablet) || justifyContent.mobile || "flex-start"
    });
const $ebf870f54152743d$var$getFlexWrapValue = (value)=>{
    if (value === "wrap") return "wrap";
    if (value === "wrap-reverse") return "wrap-reverse";
    return "nowrap";
};
const $ebf870f54152743d$var$zeroMarginPadding = null;
const $ebf870f54152743d$var$resetListStyles = null;
const $ebf870f54152743d$var$createRenderListItems = (listType)=>{
    return ({ items: items })=>{
        // Only works for paired dt/dd items. Would need different solution for different structure
        if (listType === "dl") return items.map((item, index)=>{
            if (index % 2 === 0) return /*#__PURE__*/ (0, $loA2J.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("dt", {
                        children: item
                    }),
                    items[index + 1] && /*#__PURE__*/ (0, $loA2J.jsx)("dd", {
                        children: items[index + 1]
                    })
                ]
            }, index);
            return null;
        });
        if (listType === "ol") return items.map((item, index)=>/*#__PURE__*/ (0, $loA2J.jsxs)("li", {
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
                    "_qtt8glyw _1e0c1txw _2lx21bp4 _zulp1crf _1lp7vrvc _q8t51q9y"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $62pC7.ListItemNumber), {
                        value: index + 1
                    }),
                    item
                ]
            }, index));
        return items.map((item, index)=>/*#__PURE__*/ (0, $loA2J.jsx)("li", {
                className: (0, $esG4f.default)([
                    "_kkk2n7od _1e0c1txw",
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                ]),
                children: item
            }, index));
    };
};
const $ebf870f54152743d$var$UniformListV2 = ({ listType: listType, gapv2: gapv2 = {
    mobile: "0"
}, orientation: orientation = {
    mobile: "vertical"
}, wrappedChildContent: wrappedChildContent = {
    mobile: "nowrap"
}, justifyContent: justifyContent = {
    mobile: "flex-start"
} })=>{
    const gapObject = $ebf870f54152743d$var$createResponsiveGapObject(gapv2);
    const orientationObject = $ebf870f54152743d$var$createResponsiveOrientationObject(orientation);
    const wrappedChildContentObject = $ebf870f54152743d$var$createResponsiveWrappedChildContentObject(wrappedChildContent);
    const justifyContentObject = $ebf870f54152743d$var$createResponsiveJustifyContentObject(justifyContent); // css() calls must be inline for Compiled CSS static analysis
    const listStyle = null;
    const orientationStyle = null;
    const wrappedChildContentStyle = null;
    const justifyContentStyle = null;
    const renderListItems = $ebf870f54152743d$var$createRenderListItems(listType);
    const ListTypeComponent = listType || "ul";
    return /*#__PURE__*/ (0, $loA2J.jsx)(ListTypeComponent, {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulp1a6y _19wggsi3 _pdlmxbqd",
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            "_1hmt1wth _16wj1p3b _1q2jw4vn",
            "_1e0c1txw _2lx22h65 _1lp71tnc _1inip4d6",
            "_1e0c1txw _1n261g80 _zkhy1g80 _45zz1g80",
            "_1bahown3 _e8gh2fwo _msup1t9b"
        ]),
        style: {
            "--_rkv8x9": (0, $43MIc.default)("var(--ds-space-" + gapObject.mobile + ")"),
            "--_9wptik": (0, $43MIc.default)("var(--ds-space-" + gapObject.tablet + ")"),
            "--_3wdyhk": (0, $43MIc.default)("var(--ds-space-" + gapObject.desktop + ")"),
            "--_pv2ypa": (0, $43MIc.default)(orientationObject.mobile === "horizontal" ? "row" : "column"),
            "--_dek1s0": (0, $43MIc.default)(orientationObject.tablet === "horizontal" ? "row" : "column"),
            "--_1ng513r": (0, $43MIc.default)(orientationObject.desktop === "horizontal" ? "row" : "column"),
            "--_vie9y1": (0, $43MIc.default)(justifyContentObject.mobile),
            "--_1rrey82": (0, $43MIc.default)(justifyContentObject.tablet),
            "--_pc7561": (0, $43MIc.default)(justifyContentObject.desktop)
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
            name: "listItems",
            wrapperComponent: renderListItems
        })
    });
};
var $ebf870f54152743d$export$2e2bcd8739ae039 = $ebf870f54152743d$var$UniformListV2;

});
parcelRegister("62pC7", function(module, exports) {

$parcel$export(module.exports, "ListItemNumber", function () { return $f824e5ec7d10d94f$export$448080ad20b09ab8; });
/* list-item-number.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $5ohHq = parcelRequire("5ohHq");
const $f824e5ec7d10d94f$export$448080ad20b09ab8 = (props)=>{
    const { value: value } = props;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _4t3ickbl _1bsbckbl _2rko1osq _11q76kkz _1e0c1txw _1bah1h6o _4cvr1h6o _syaz1tj6 _y3gn1h6o _ect41pz4 _1wybgktf _zg8l4jg8 _k48p1fw0 _vwz4183y"
        ]),
        style: {
            "--_1qa6cp7": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue200")),
            "--_1tgiy09": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue900")),
            "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
        },
        children: value
    });
};

});



parcelRegister("kgmR5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("fq2e7")).default; });

var $fq2e7 = parcelRequire("fq2e7");

});
parcelRegister("fq2e7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a78475915aa8c839$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $5VMi0 = parcelRequire("5VMi0");
const $a78475915aa8c839$export$d64e2f97651f7f4d = (props)=>{
    const appearance = props.color === "red" ? "danger" : props.color || "neutral";
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5VMi0.Lozenge), {
        appearance: appearance,
        text: props.text
    });
};
var $a78475915aa8c839$export$2e2bcd8739ae039 = $a78475915aa8c839$export$d64e2f97651f7f4d;

});


parcelRegister("liGDD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("9ScPv")).default; });

var $9ScPv = parcelRequire("9ScPv");

});
parcelRegister("9ScPv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cb2f8cde4557d14$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $aiugz = parcelRequire("aiugz");

var $1rLfN = parcelRequire("1rLfN");
// Pass modalSize as the width directly to the Modal component
const $0cb2f8cde4557d14$var$UniformModal = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1rLfN.ModalLink), {
        modalTitle: props.modalTitle,
        modalCloseLabel: props.modalCloseLabel,
        ctaText: props.ctaText,
        modalWidth: props.modalSize,
        modalLinkType: props.modalLinkType,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
            name: "modalContent"
        })
    });
};
var $0cb2f8cde4557d14$export$2e2bcd8739ae039 = $0cb2f8cde4557d14$var$UniformModal;

});
parcelRegister("1rLfN", function(module, exports) {

$parcel$export(module.exports, "ModalLink", function () { return $8bb80322af964ea2$export$cf363aa9ce73688b; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $1O6nN = parcelRequire("1O6nN");

var $edRuD = parcelRequire("edRuD");
const $8bb80322af964ea2$export$cf363aa9ce73688b = ({ modalTitle: modalTitle, modalCloseLabel: modalCloseLabel, children: children, ctaText: ctaText, modalWidth: modalWidth, modalLinkType: modalLinkType = "modal" })=>{
    const [isOpen, setIsOpen] = (0, $iSvIT.useState)(false);
    const openModal = (e)=>{
        e.preventDefault();
        setIsOpen(true);
    };
    const closeModal = (0, $iSvIT.useCallback)(()=>setIsOpen(false), []);
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $1O6nN.Link), {
                onClick: openModal,
                "aria-label": "modal-link",
                text: ctaText,
                href: "#modal-section",
                type: modalLinkType
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $edRuD.Modal), {
                closeModal: closeModal,
                closeLabel: modalCloseLabel,
                title: modalTitle,
                isOpen: isOpen,
                width: modalWidth,
                children: children
            })
        ]
    });
};

});



parcelRegister("gPr7r", function(module, exports) {

$parcel$export(module.exports, "useProductTemplateContext", function () { return $205f85a083271d56$export$9aa15cd8273c8730; });
$parcel$export(module.exports, "default", function () { return $205f85a083271d56$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
const $205f85a083271d56$var$ProductTemplateContext = /*#__PURE__*/ (0, $iSvIT.createContext)({
    template: null,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setTemplate: ()=>{}
});
const $205f85a083271d56$export$d254455f6d2132ac = ({ children: children })=>{
    const [template, setTemplate] = (0, $iSvIT.useState)(null);
    const value = (0, $iSvIT.useMemo)(()=>({
            template: template,
            setTemplate: setTemplate
        }), [
        template
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($205f85a083271d56$var$ProductTemplateContext.Provider, {
        value: value,
        children: children
    });
};
const $205f85a083271d56$export$9aa15cd8273c8730 = ()=>{
    const context = (0, $iSvIT.useContext)($205f85a083271d56$var$ProductTemplateContext);
    if (!context) throw new Error("useProductTemplateContext must be used within a ProductTemplateContextProvider");
    return context;
};
var $205f85a083271d56$export$2e2bcd8739ae039 = $205f85a083271d56$export$d254455f6d2132ac;

});

parcelRegister("bMQWw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("k3kI6")).default; });

var $k3kI6 = parcelRequire("k3kI6");

});
parcelRegister("k3kI6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fedb85474fab90c9$export$2e2bcd8739ae039; });
/* pagination.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $8LSiz = parcelRequire("8LSiz");
const $fedb85474fab90c9$var$centerStyles = null;
const $fedb85474fab90c9$var$UniformPagination = (props)=>{
    // Generate pages array from total pages
    const pagesArray = Array.from({
        length: props.pages
    }, (_, i)=>i + 1); // For now, using defaults until page logic is implemented
    const selectedIndex = 0;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1h6o _1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8LSiz.Pagination), {
            pages: pagesArray,
            selectedIndex: selectedIndex
        })
    });
};
var $fedb85474fab90c9$export$2e2bcd8739ae039 = $fedb85474fab90c9$var$UniformPagination;

});


parcelRegister("cceBl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $1f0ddae1c4249f8b$export$2e2bcd8739ae039; });

var $kIHPB = parcelRequire("kIHPB");
var $1f0ddae1c4249f8b$export$2e2bcd8739ae039 = (0, $kIHPB.default);

});
parcelRegister("kIHPB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a207c7df7bd4bbe$export$2e2bcd8739ae039; });
/* product-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");
const $0a207c7df7bd4bbe$export$fef9b561ff2e7cb1 = ({ id: id, name: name, description: description, href: href, className: className, imgSrc: imgSrc, imgAlt: imgAlt, type: type = "secondary" })=>{
    const localizedHref = (0, $3FBn4.useLocalizedHref)(href !== null && href !== void 0 ? href : "");
    if (typeof href === "undefined") return null;
    const formattedHref = (0, $3FBn4.isLocalizableHref)(href) ? localizedHref : href;
    const iconSize = type === "primary" ? 44 : 32;
    let normalizedId;
    if (id === "jira-software") normalizedId = "jira";
    else if (id === "atlassian-access") normalizedId = "guard";
    else if (id) // The id for some products in Contentful have "-" in between (ex. jira-service-management), so we need to remove it to match data-product-key values in the global nav
    normalizedId = id.replace(/-/g, "");
    else normalizedId = name.replace(/ /g, "").toLowerCase();
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1bsb1osq _1mouu2gc _b27r17la",
            className
        ]),
        "data-testid": "wae-product-card",
        style: {
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("a", {
            href: formattedHref,
            target: (0, $3FBn4.isLocalizableHref)(href) ? "" : "_blank",
            rel: (0, $3FBn4.isLocalizableHref)(href) ? "" : "noreferrer",
            "aria-label": name,
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-event-container": "customerStories",
            "data-product-key": normalizedId,
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _1aax1e5h _12l2utpp _4cvr1h6o _1bah1h6o _4t3i1ady _1bsb1ady _1wpz1q9y"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                        image: {
                            src: imgSrc !== null && imgSrc !== void 0 ? imgSrc : "https://dam-cdn.atl.orangelogic.com/AssetLink/5sd7w3j2d7rdm7354yi413c5s1eo6s10.webp",
                            alt: imgAlt !== null && imgAlt !== void 0 ? imgAlt : "",
                            width: iconSize,
                            height: iconSize
                        }
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _zulpv77o _1q51v77o _1tke1ady",
                        "_1b2mvd4q _gp0igktf",
                        !description && "_1bah1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: "h6",
                            children: name
                        }),
                        description && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: "body-sm",
                            children: description
                        })
                    ]
                })
            ]
        })
    });
};
const $0a207c7df7bd4bbe$var$cardStyle = null;
const $0a207c7df7bd4bbe$var$iconStyle = null;
const $0a207c7df7bd4bbe$var$textContainerStyle = null;
const $0a207c7df7bd4bbe$var$noDescriptionStyle = null;
const $0a207c7df7bd4bbe$var$overrideTextStyling = null;
var $0a207c7df7bd4bbe$export$2e2bcd8739ae039 = $0a207c7df7bd4bbe$export$fef9b561ff2e7cb1;

});


parcelRegister("7D1nQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $ba308be7eb70f97b$export$2e2bcd8739ae039; });

var $1UUq1 = parcelRequire("1UUq1");
var $ba308be7eb70f97b$export$2e2bcd8739ae039 = (0, $1UUq1.PullQuote);

});

parcelRegister("adl56", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("koVMZ")).default; });

var $koVMZ = parcelRequire("koVMZ");

});
parcelRegister("koVMZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73e8cc6d4da7295e$export$2e2bcd8739ae039; });
/* single-tab.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $aiugz = parcelRequire("aiugz");
// eslint-disable-next-line complexity
const $73e8cc6d4da7295e$var$UniformSingleTab = (props)=>{
    const { orientation: orientation = {
        mobile: "vertical"
    }, gap: gap = {
        mobile: "0"
    } } = props;
    var _gap_mobile, _gap_tablet, _ref, _gap_desktop, _ref1, _ref2;
    const gapObject = {
        mobile: (_gap_mobile = gap.mobile) !== null && _gap_mobile !== void 0 ? _gap_mobile : "0",
        // @ts-ignore
        tablet: (_ref = (_gap_tablet = gap === null || gap === void 0 ? void 0 : gap.tablet) !== null && _gap_tablet !== void 0 ? _gap_tablet : gap.mobile) !== null && _ref !== void 0 ? _ref : "0",
        // @ts-ignore
        desktop: (_ref2 = (_ref1 = (_gap_desktop = gap === null || gap === void 0 ? void 0 : gap.desktop) !== null && _gap_desktop !== void 0 ? _gap_desktop : gap === null || gap === void 0 ? void 0 : gap.tablet) !== null && _ref1 !== void 0 ? _ref1 : gap.mobile) !== null && _ref2 !== void 0 ? _ref2 : "0"
    };
    const styles = null;
    const orientationObject = {
        mobile: orientation.mobile || "vertical",
        // @ts-ignore
        tablet: orientation.tablet || orientation.mobile || "vertical",
        desktop: // @ts-ignore
        orientation.desktop || // @ts-ignore
        orientation.tablet || orientation.mobile || "vertical"
    };
    const orientationStyle = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1bsb1osq _4t3i1wug _1e0c1txw _zulp1a6y _19wggsi3 _pdlmxbqd",
            "_1e0c1txw _2lx22h65 _1lp71tnc _1inip4d6"
        ]),
        style: {
            "--_rkv8x9": (0, $43MIc.default)("var(--ds-space-" + gapObject.mobile + ")"),
            "--_9wptik": (0, $43MIc.default)("var(--ds-space-" + gapObject.tablet + ")"),
            "--_3wdyhk": (0, $43MIc.default)("var(--ds-space-" + gapObject.desktop + ")"),
            "--_pv2ypa": (0, $43MIc.default)(orientationObject.mobile === "horizontal" ? "row" : "column"),
            "--_dek1s0": (0, $43MIc.default)(orientationObject.tablet === "horizontal" ? "row" : "column"),
            "--_1ng513r": (0, $43MIc.default)(orientationObject.desktop === "horizontal" ? "row" : "column")
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
            name: "tabContents"
        })
    });
};
var $73e8cc6d4da7295e$export$2e2bcd8739ae039 = $73e8cc6d4da7295e$var$UniformSingleTab;

});


parcelRegister("5znlu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("gmi9U")).default; });

var $gmi9U = parcelRequire("gmi9U");

});
parcelRegister("gmi9U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e77a1f912177c1d$export$2e2bcd8739ae039; });
/* split-color-background-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $aiugz = parcelRequire("aiugz");
const $0e77a1f912177c1d$var$UniformSplitColorBackgroundContainer = ({ topColor: topColor, bottomColor: bottomColor, sectionDivider: sectionDivider, extendBackgroundColor: extendBackgroundColor })=>{
    const baseStyle = null;
    const horizontalStyle = null;
    const highLeft = null;
    const highRight = null;
    const coverStyles = null;
    const sectionDividerComponent = /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_kqswstnw _4t3iq9zu _1bsb1osq _11q7jj3k _152t1ssb _t9ec1i34 _1kt9b3bt _cfu11ule _kfgt1osq _1mp41osq _1cs8stnw _iajmidpf _1rus1utj",
            bottomColor === "transparent" && sectionDivider === "high-left" && "_mkrz7yzi",
            bottomColor === "transparent" && sectionDivider === "high-right" && "_mkrz1swj",
            sectionDivider === "high-left" && "_tgsmte2m",
            sectionDivider === "high-right" && "_tgsmrjfx"
        ]),
        style: {
            "--_nlw01g": (0, $43MIc.default)(topColor),
            "--_130a3qa": (0, $43MIc.default)(bottomColor)
        }
    });
    const extendedBackgroundColorComponent = /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_kqswstnw _1bsbauwl _4t3i1osq _14b5zqdx _b8yq87gh _1e021ssb _t9eczr6s",
            sectionDivider && "_1kt9b3bt _cfu11ule _1mp41osq _1cs8stnw _iajmidpf _1rusjj3k _kfgt2ts6 _aetrb3bt _1ywu1ule _z0ai1osq _18postnw _1bqq1mrw _1gufidpf _1hfk1utj _1qdg2ts6",
            !sectionDivider && "_11q7eqnl"
        ]),
        style: {
            "--_nlw01g": (0, $43MIc.default)(topColor),
            "--_130a3qa": (0, $43MIc.default)(bottomColor)
        },
        children: sectionDivider && sectionDividerComponent
    });
    const slotWrapper = ({ items: items })=>{
        return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_kqswh2mm"
            ]),
            children: items
        });
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_kqswh2mm _9luy1wqb _ce5au29b _wfa7llbu",
            !extendBackgroundColor && sectionDivider && "_1kt9b3bt _cfu11ule _1mp41osq _1cs8stnw _iajmidpf _1rusjj3k _kfgt2ts6 _aetrb3bt _1ywu1ule _z0ai1osq _18postnw _1bqq1mrw _1gufidpf _1hfk1utj _1qdg2ts6",
            !extendBackgroundColor && !sectionDivider && "_11q7eqnl"
        ]),
        style: {
            "--_nlw01g": (0, $43MIc.default)(topColor),
            "--_130a3qa": (0, $43MIc.default)(bottomColor)
        },
        children: [
            sectionDivider && !extendBackgroundColor && sectionDividerComponent,
            extendBackgroundColor && extendedBackgroundColorComponent,
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
                name: "component",
                wrapperComponent: sectionDivider ? slotWrapper : undefined
            })
        ]
    });
};
var $0e77a1f912177c1d$export$2e2bcd8739ae039 = $0e77a1f912177c1d$var$UniformSplitColorBackgroundContainer;

});


parcelRegister("diZQT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("h3wk5")).default; });

var $h3wk5 = parcelRequire("h3wk5");

});
parcelRegister("h3wk5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9034dfb6d5e5a2d2$export$2e2bcd8739ae039; });
// @ts-ignore

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $gPr7r = parcelRequire("gPr7r");

var $gkV6l = parcelRequire("gkV6l");

var $cX9ng = parcelRequire("cX9ng");

var $knAj5 = parcelRequire("knAj5");

var $lbVpk = parcelRequire("lbVpk");

var $3FBn4 = parcelRequire("3FBn4");
const $9034dfb6d5e5a2d2$var$UniformTemplateModalButton = (props)=>{
    const { text: text, productKey: productKey, templateName: templateName, pluginModuleKey: pluginModuleKey, href: href } = props;
    const { openModalForTemplate: openModalForTemplate } = (0, $gkV6l.useSiteSelectorContext)();
    const { setTemplate: setTemplate } = (0, $gPr7r.useProductTemplateContext)();
    // AIS = Atlassian Identity Service - provides user's existing Atlassian sites
    const aisSites = (0, $knAj5.useSitesWithCurrentProduct)();
    const locale = (0, $3FBn4.useLocale)();
    const localizedSignupHref = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup");
    const [buttonProps, setButtonProps] = (0, $iSvIT.useState)({
        href: $9034dfb6d5e5a2d2$var$getDefaultHref({
            productKey: productKey,
            locale: locale
        })
    });
    const fullStargateProductKey = productKey === "jira-service-management" ? "jira-servicedesk.ondemand" : `${productKey}.ondemand`;
    (0, $iSvIT.useEffect)(()=>{
        if (pluginModuleKey && productKey) {
            const templateData = {
                templateId: pluginModuleKey,
                templateName: templateName,
                productKey: fullStargateProductKey
            };
            setTemplate(templateData);
            var _aisSites_map;
            // Get site URLs for the current product
            const siteUrls = (_aisSites_map = aisSites === null || aisSites === void 0 ? void 0 : aisSites.map((site)=>site.url)) !== null && _aisSites_map !== void 0 ? _aisSites_map : [];
            // Determine action based on user's sites
            const action = (0, $cX9ng.getTemplateAction)({
                templateData: templateData,
                siteUrls: siteUrls,
                localizedSignupHref: localizedSignupHref
            });
            if (action.type === "modal") setButtonProps({
                onClick: (event)=>{
                    event.stopPropagation();
                    event.preventDefault();
                    openModalForTemplate(templateData);
                }
            });
            else setButtonProps({
                href: action.href
            });
        } else if (href) setButtonProps({
            href: (0, $3FBn4.getLocalizedHref)({
                href: href,
                locale: locale
            })
        });
        return ()=>{
            setTemplate(null);
        };
    }, [
        openModalForTemplate,
        templateName,
        pluginModuleKey,
        fullStargateProductKey,
        href,
        productKey,
        locale,
        aisSites,
        localizedSignupHref,
        setTemplate
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lbVpk.Button), (0, $6iHNw._)((0, $7Knp0._)({}, buttonProps), {
        children: text
    }));
};
function $9034dfb6d5e5a2d2$var$getDefaultHref(args) {
    const { locale: locale, productKey: productKey } = args;
    if (productKey === "jira-software") return (0, $3FBn4.getLocalizedHref)({
        href: "/try/cloud/signup?bundle=jira&edition=free",
        locale: locale
    });
    if (productKey === "confluence") return (0, $3FBn4.getLocalizedHref)({
        href: "/try/cloud/signup?bundle=confluence&edition=free",
        locale: locale
    });
    if (productKey === "jira-service-management") return (0, $3FBn4.getLocalizedHref)({
        href: "/try/cloud/signup?bundle=jira-service-management&edition=free",
        locale: locale
    });
    return "";
}
var $9034dfb6d5e5a2d2$export$2e2bcd8739ae039 = $9034dfb6d5e5a2d2$var$UniformTemplateModalButton;

});
parcelRegister("cX9ng", function(module, exports) {

$parcel$export(module.exports, "getTemplateAction", function () { return $9286df2b38d515c7$export$4935503ffd4d8306; });

var $i8kxh = parcelRequire("i8kxh");

var $hG0Y6 = parcelRequire("hG0Y6");
const $9286df2b38d515c7$export$4935503ffd4d8306 = (params)=>{
    const { templateData: templateData, siteUrls: siteUrls, redirectToIdentity: redirectToIdentity, internalLinkAfterIdentity: internalLinkAfterIdentity, localizedSignupHref: localizedSignupHref } = params;
    // If user has existing sites, show modal
    if (siteUrls.length > 0) return {
        type: "modal",
        templateData: templateData
    };
    // Otherwise, redirect directly
    const href = $9286df2b38d515c7$var$getRedirectHref({
        templateData: templateData,
        redirectToIdentity: redirectToIdentity,
        internalLinkAfterIdentity: internalLinkAfterIdentity,
        localizedSignupHref: localizedSignupHref
    });
    return {
        type: "redirect",
        href: href
    };
};
const $9286df2b38d515c7$var$getRedirectHref = (params)=>{
    const { templateData: templateData, redirectToIdentity: redirectToIdentity, internalLinkAfterIdentity: internalLinkAfterIdentity, localizedSignupHref: localizedSignupHref } = params;
    const { templateId: templateId, templateName: templateName } = templateData;
    if (redirectToIdentity && internalLinkAfterIdentity) return $9286df2b38d515c7$var$getIdentityUrl(templateId, templateName, internalLinkAfterIdentity);
    return $9286df2b38d515c7$var$getCloudSignupUrl(templateData, localizedSignupHref, internalLinkAfterIdentity);
};
const $9286df2b38d515c7$var$isJiraProduct = (productKey)=>{
    return [
        (0, $i8kxh.ProductKeys).JIRA_CORE,
        (0, $i8kxh.ProductKeys).JIRA_SERVICE_DESK,
        (0, $i8kxh.ProductKeys).JIRA_SOFTWARE,
        (0, $i8kxh.ProductKeys).JIRA_PRODUCT_DISCOVERY
    ].includes(productKey);
};
const $9286df2b38d515c7$var$getCloudSignupUrl = (templateData, localizedSignupHref, internalLinkAfterIdentity)=>{
    const { templateId: templateId, templateName: templateName, productKey: productKey } = templateData;
    let url = `${localizedSignupHref}?product=${productKey}&templateId=${templateId}&edition=free`;
    if ($9286df2b38d515c7$var$isJiraProduct(productKey)) {
        const urlParams = new URLSearchParams(location.search);
        if (!urlParams.has("p")) urlParams.append("templateModal", templateId);
        url += `&continue=${encodeURIComponent(`${location.href}?${urlParams.toString()}`)}`;
    } else if (productKey === (0, $i8kxh.ProductKeys).CONFLUENCE) {
        const continueUrl = `${(0, $hG0Y6.getWacIntegrationUrl)()}${internalLinkAfterIdentity !== null && internalLinkAfterIdentity !== void 0 ? internalLinkAfterIdentity : ""}?templateId=${templateId + encodeURIComponent("&templateName=" + encodeURIComponent(templateName))}`;
        url = `${url}&continue=${encodeURIComponent(continueUrl)}`;
    }
    return url;
};
const $9286df2b38d515c7$var$getIdentityUrl = (templateId, templateName, internalLinkAfterIdentity)=>{
    const loginUrl = `${(0, $hG0Y6.getIdentityBaseUrl)()}/login?`;
    const continueUrl = `${(0, $hG0Y6.getWacIntegrationUrl)()}${internalLinkAfterIdentity}?templateName=${encodeURIComponent(templateName)}&templateId=${templateId}`;
    return `${loginUrl}&continue=${encodeURIComponent(continueUrl)}`;
};

});



parcelRegister("6NpvY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("1GDqm")).default; });

var $1GDqm = parcelRequire("1GDqm");

});
parcelRegister("1GDqm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23620155247a97b9$export$2e2bcd8739ae039; });
/* text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $4XrxY = parcelRequire("4XrxY");

var $4jHZw = parcelRequire("4jHZw");
const $23620155247a97b9$var$UniformText = ({ text: text, style: style = "body-lg", alignment: alignment = "left", headingLevel: headingLevel })=>{
    const [textRef, textColor] = (0, $4jHZw.useStylePropertyVariableValueFromParent)("--dxp-container-text-color");
    const alignmentStyle = null;
    const boldStyling = null;
    const resetMargin = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            ref: textRef,
            className: (0, $esG4f.default)([
                style.includes("bold") && "_3dt51fw0",
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                "_y3gnoues",
                style
            ]),
            role: headingLevel ? `heading` : undefined,
            "aria-level": headingLevel,
            style: (0, $6iHNw._)((0, $7Knp0._)({}, textColor ? {
                color: textColor
            } : undefined), {
                "--_1v0xqnb": (0, $43MIc.default)(alignment)
            }),
            children: text
        })
    });
};
var $23620155247a97b9$export$2e2bcd8739ae039 = $23620155247a97b9$var$UniformText;

});


parcelRegister("jzDAp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("4d4f5")).default; });

var $4d4f5 = parcelRequire("4d4f5");
 // export type { UniformVariantProps } from "./src/variant";

});
parcelRegister("4d4f5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e222d054d5504f7$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $aiugz = parcelRequire("aiugz");
const $1e222d054d5504f7$var$UniformVariant = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
        name: "content"
    });
};
var $1e222d054d5504f7$export$2e2bcd8739ae039 = $1e222d054d5504f7$var$UniformVariant;

});


parcelRegister("3Z0Az", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("bR2Mn")).default; });

var $bR2Mn = parcelRequire("bR2Mn");

});
parcelRegister("bR2Mn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50c82a39185e8ede$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $aiugz = parcelRequire("aiugz");
const $50c82a39185e8ede$var$UniformVariantContainer = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
        name: "content"
    });
var $50c82a39185e8ede$export$2e2bcd8739ae039 = $50c82a39185e8ede$var$UniformVariantContainer;

});


parcelRegister("4sbR8", function(module, exports) {

$parcel$export(module.exports, "UniformMissingComponent", function () { return $bf3a6afbcc6e7c21$export$ec79654869ecfe2e; });
/* uniform-missing-component.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $bf3a6afbcc6e7c21$export$ec79654869ecfe2e = ({ componentName: componentName })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        id: `UNIFORM-MISSING-COMPONENT-${componentName}`,
        "data-nosnippet": true,
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            "_1e0cglyw"
        ])
    });
};

});


var $lgDo7 = parcelRequire("lgDo7");

var $7Tq4R = parcelRequire("7Tq4R");
(0, $7Tq4R.init)((0, $lgDo7.UniformEntryPage));


//# sourceMappingURL=uniform-entry-page.c5757b74.js.map
